import { useFormikContext } from 'formik';
import React, { FC, useEffect, useState } from 'react';
import { useWizardSummaryContext } from '../wizard/wizardSummaryContext';

interface SettingSummaryFieldProps {
    displayName: string;
    accessor: string;
    value?: string;
    field?: any;
}

export const SettingSummaryField: FC<SettingSummaryFieldProps> = ({ displayName, accessor, value, field }) => {
    const { values } = useFormikContext();
    const { summary } = useWizardSummaryContext();
    const [assignedValue, setAssignedValue] = useState(value
        ?? summary.find(item => item.value === accessor)?.label
        ?? accessor.split('.').reduce((previous, current) => {
            return previous?.[current]
        }, values as any))

    useEffect(() => {
        const summaryEntryIndex = summary.findIndex(item => {
            return item.value === accessor || item.value === accessor.substr(0, accessor.lastIndexOf('.'))+'.value';
        });
        if (summaryEntryIndex >= 0) {
            setAssignedValue(summary[summaryEntryIndex].label);
        }
        else {
            let result = accessor.split('.').reduce((previous, current) => {
                let potentialName = previous?.[current];
                if ((potentialName === undefined || potentialName.length === 0) && current === "name") {
                    potentialName = previous?.value;
                }
                return potentialName
            }, values as any)

            if (field?.options) {
                const matchingOption = field.options.find(option => option.id === result);
                result = matchingOption?.name || result;
            }

            setAssignedValue(result);
        }
    }, [values, summary])

    return (!!assignedValue
        ? <span className="p-1 text-xs text-gray-600">{displayName}: <span className="text-sm text-black">{assignedValue}</span></span>
        : null);
};
